var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:[
    'select-item',
    { selected: _vm.selected },
    _vm.size ? `select-item-${_vm.size}` : ''
  ],attrs:{"href":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }